import Logo from './Logo';
import LogoCorePackages from './Logo.core_packages';
import { withFeatureBranch } from '../redux/flags';
export default withFeatureBranch({ core_packages: LogoCorePackages })(Logo);
//# sourceMappingURL=index.js.map